import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default () => <CheckCircleIcon style={{ color: '#add8e6' }} />;
